import { fetchEndpoint } from "../../network";

export default {
  // 都市圈列表
  list(params) {
    return fetchEndpoint("/channel/list", "GET", params);
  },
  // 轮播图列表
  carouselList(params) {
    return fetchEndpoint("/channel/carouselList", "GET", params);
  },
  // 内容列表
  contentList(params) {
    return fetchEndpoint("/channel/contentList", "GET", params);
  },
  // 新增
  insert(params) {
    return fetchEndpoint("/channel/insert", "POST", params);
  },
  // 编辑
  update(params) {
    return fetchEndpoint("/channel/update", "POST", params);
  },
  //批量操作
  batch(params) {
    return fetchEndpoint("/channel/updateBatch", "GET", params);
  },
  
};
